import React, { Component } from 'react'

// Functions
import { addStyle, removeStyle } from '../../../functions/textEditorFunctions'

// css
import css from '../css/styleSettings.css'



class DisplaySetting extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  change = (e) => {
    const { _this, styleName } = this.props
    const value = e.target.value

    if (value === '') {
      removeStyle(_this, styleName)
    } else {
      addStyle(_this, {
        style: styleName,
        value
      })
    }
  }

  reset = () => {
    const { _this, styleName } = this.props

    if (styleName) {
      removeStyle(_this, styleName)
    }
  }

  render() {
    const { _this, styleName } = this.props
    const display = _this.state.style[styleName]
    const label = this.props.label || 'การแสดงผล (display)'


    return (
      <div>
        <table>
          <tbody>
            <tr>
              <td className="pd-0 font-0-7">{label}</td>
              <td className="pd-0 font-0-7 text-right">
                <a className={css.btn} onClick={this.reset}>ค่าเดิม</a>
              </td>
            </tr>
          </tbody>
        </table>

        <div>
          <div className={css.boxInput}>
            <table>
              <tbody>
                <tr>
                  <td width="50%" className="pd-0 font-0-8 center">
                    <select
                      className={`browser-default ${css.input} ${css.select}`}
                      onChange={this.change}
                      value={display || '0'}>

                      <option value="">เลือก</option>
                      <option value="block">ขึ้นบรรทัดใหม่ (block)</option>
                      <option value="inline-block">อยู่บรรทัดเดียวกัน (inline-block)</option>
                      <option value="table">table</option>
                      <option value="none">ซ่อน (none)</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }
}

export default DisplaySetting
